/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner {
    /**
     * 住所
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'beneficialOwnerType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum;
    /**
     * 生年月日
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'birthday'?: string;
    /**
     * 法人との関係性
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'corporateRelationships'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum;
    /**
     * 居住国
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'countryResidence'?: string;
    /**
     * 性別
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'gender'?: GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum;
    /**
     * 外国人PEPsに該当するか
     * @type {boolean}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'isPoliticallyExposedPersons': boolean;
    /**
     * 氏名・法人名
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInner
     */
    'name': string;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum = {
    corporation: 'CORPORATION',
    person: 'PERSON'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerBeneficialOwnerTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum = {
    businessExecutor: 'BUSINESS_EXECUTOR',
    hasControllingInfluenceOverBusinessActivity: 'HAS_CONTROLLING_INFLUENCE_OVER_BUSINESS_ACTIVITY',
    hasRightOver25Per: 'HAS_RIGHT_OVER_25PER',
    hasRightOver50Per: 'HAS_RIGHT_OVER_50PER'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerCorporateRelationshipsEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum = {
    female: 'FEMALE',
    male: 'MALE'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerBeneficialOwnersInnerGenderEnum];


